import { FC } from 'react';
import cx from 'classnames/bind';

import BoxesFunny from '@/assets/boxesFunny.png';
import CheckCircle from '@/assets/checkCircle.svg';
import { Modal } from '@/components/Modal';

import styles from './ModalCorrectOrder.module.scss';

interface ModalCorrectOrderProps {
  modal: string;
  setModal: (value: string) => void;
  setStep: (value: number) => void;
  cigarettes: string;
  answers: string[];
}

const cn = cx.bind(styles);

const ModalCorrectOrder: FC<ModalCorrectOrderProps> = ({
  modal,
  setModal,
  setStep,
  cigarettes,
  answers,
}) => {
  const handleClick = () => {
    setStep(3);
    setModal('');
  };

  return modal === 'correctOrder' ? (
    <Modal
      src={BoxesFunny}
      title="Заказ собран верно"
      textButton="Выбрать новый заказ"
      handleClick={() => handleClick()}
    >
      <div className={cn('modal-description')}>
        <p className={cn('modal-text')}>
          Так держать! Сигареты {cigarettes} действительно обладают
          характеристиками:
        </p>
      </div>
      <ul className={cn('modal-answers')}>
        {answers.map((answer) => (
          <li key={answer} className={cn('modal-answer')}>
            <img className={cn('modal-icon')} src={CheckCircle} alt="Галочка" />
            {answer}
          </li>
        ))}
      </ul>
    </Modal>
  ) : null;
};

export default ModalCorrectOrder;
